import { switchAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';
import { StyleFunctionProps, cssVar } from '@chakra-ui/theme-tools';

const { definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');
const $bg = cssVar('switch-bg');

const baseStyleTrack = defineStyle((props) => {
  const { colorScheme: c } = props;
  return {
    _checked: {
      [$bg.variable]: c === 'black' ? 'colors.gray.1000' : `colors.${c}.800`,
      _dark: {
        [$bg.variable]: c === 'black' ? 'colors.gray.900' : `colors.${c}.600`,
      },
    },
  };
});
const baseStyleLabel = defineStyle({
  ml: 0,
});
const baseStyleThumb = defineStyle({
  boxShadow: 'lg',
});

const baseStyle = definePartsStyle((props) => ({
  thumb: baseStyleThumb,
  track: baseStyleTrack(props),
  label: baseStyleLabel,
}));

const variants = {
  bulky: (props: StyleFunctionProps) => {
    const { colorScheme: c } = props;
    return {
      thumb: {
        boxShadow: 'xl',
        h: 7,
        w: 7,
        _checked: {
          transform: 'matrix(1,0,0,1,18,0)',
        },
      },
      track: {
        _checked: {
          bg: `${c}.800`,
        },
        h: 7,
        w: 12,
      },
    };
  },
};

const sizes = {
  lg: definePartsStyle({
    container: {
      [$width.variable]: '2.4rem',
      [$height.variable]: 'sizes.5',
    },
  }),
  xl: definePartsStyle({
    container: {
      [$width.variable]: '2.875rem',
      [$height.variable]: 'sizes.6',
    },
  }),
  '2xl': definePartsStyle({
    container: {
      [$width.variable]: '3.2rem',
      [$height.variable]: 'sizes.7',
    },
  }),
};

export default {
  baseStyle,
  variants,
  sizes,
};
